import { memo } from 'react'

import s from './LoginButton.module.scss'

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  icon: React.ReactNode
  iconWrapperColor: string
  title: string
}

export const LoginButton = memo(({ icon, iconWrapperColor, title, onClick }: Props) => {
  return (
    <button className={s.button} onClick={onClick}>
      <div className={s.iconWrapper} style={{ backgroundColor: iconWrapperColor }}>
        {icon}
      </div>
      <span className={s.title}>{title}</span>
    </button>
  )
})
